<template>
  <div
    class="flex flex-col justify-center items-center min-h-screen px-4 bg-cover bg-center bg-no-repeat"
    style="background-image: url('/fondologin.jpg');"
  >
    <div class="w-full max-w-sm bg-white/90 dark:bg-gray-800/90 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md p-6">

      <!-- Logo -->
      <div class="flex justify-center items-center mb-4">
        <img src="/favicon.ico" class="w-24 h-auto" alt="Logo" />
      </div>

      <!-- Encabezado -->
      <div class="flex flex-col items-center mb-6">
        <div class="bg-blue-100 dark:bg-blue-700 text-blue-600 dark:text-white p-3 rounded-full mb-2">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 11c1.104 0 2-.896 2-2V7a2 2 0 10-4 0v2c0 1.104.896 2 2 2zm6 2a6 6 0 11-12 0c0-1.304.418-2.506 1.124-3.478a9.985 9.985 0 011.376-1.522C9.935 7.27 10.948 7 12 7s2.065.27 2.5.5c.509.256.993.623 1.376 1.522A5.996 5.996 0 0118 13z" />
          </svg>
        </div>
        <h1 class="text-xl font-bold text-gray-800 dark:text-white">Completar Registro</h1>
        <p v-if="email" class="text-sm text-gray-500 dark:text-gray-400 mt-1 text-center">
          Hola, completa tu contraseña para acceder a tu cuenta y solicitar tu cita.
        </p>
      </div>

      <!-- Formulario -->
      <form @submit.prevent="crearCuenta" class="space-y-4">
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Contraseña
          </label>
          <input
            type="password"
            id="password"
            v-model="password"
            required
            class="mt-1 block w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Ingresa tu contraseña"
          />
        </div>

        <div>
          <label for="confirmPassword" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Confirmar Contraseña
          </label>
          <input
            type="password"
            id="confirmPassword"
            v-model="confirmPassword"
            required
            class="mt-1 block w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Repite tu contraseña"
          />
        </div>

        <button
          type="submit"
          class="w-full py-2 px-4 text-white font-semibold bg-blue-600 hover:bg-blue-700 rounded-lg transition disabled:opacity-50"
          :disabled="submitting"
        >
          {{ submitting ? "Creando..." : "Crear Cuenta" }}
        </button>

        <p v-if="errorMessage" class="text-red-600 text-sm text-center mt-2">
          {{ errorMessage }}
        </p>
      </form>
    </div>
  </div>
</template>


<script>
import {
  getAuth,
  createUserWithEmailAndPassword,
  updatePassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import {
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "@/firebase";

export default {
  data() {
    return {
      email: this.$route.query.email || "",
      password: "",
      confirmPassword: "",
      errorMessage: "",
      submitting: false,

      // === flujo paciente existente ===
      prospectoId:
        this.$route.params.prospectoId ||
        this.$route.params.uid ||
        this.$route.params.pacienteId ||
        null,
      prospectoData: null,
      registroCol: null, // 'prospectos' | 'pacientes' | 'prePacientes'

      // === añadido para enfermeros ===
      // Por qué: el enlace público usa :uid; algunas rutas internas usan :id.
      userId: this.$route.params.uid || this.$route.params.id || null,
      role: "paciente", // Por qué: no inferir del path; lo fijamos leyendo Firestore.
    };
  },

  async mounted() {
    try {
      // --- flujo que ya tenías para prospectos / prePacientes / pacientes ---
      if (this.prospectoId) {
        let ref = doc(db, "prospectos", this.prospectoId);
        let snap = await getDoc(ref);

        if (snap.exists()) {
          this.registroCol = "prospectos";
          this.prospectoData = snap.data();
        } else {
          ref = doc(db, "prePacientes", this.prospectoId);
          snap = await getDoc(ref);

          if (snap.exists()) {
            this.registroCol = "prePacientes";
            this.prospectoData = snap.data();
          } else {
            ref = doc(db, "pacientes", this.prospectoId);
            snap = await getDoc(ref);

            if (snap.exists()) {
              this.registroCol = "pacientes";
              this.prospectoData = snap.data();
            } else {
              this.registroCol = null;
              this.prospectoData = null;
            }
          }
        }
      }

      // --- NUEVO: detectar invitación de ENFERMERO por uid ---
      if (this.userId) {
        const refEnf = doc(db, "enfermeros", this.userId);
        const snapEnf = await getDoc(refEnf);
        if (snapEnf.exists()) {
          this.registroCol = "enfermeros";
          this.prospectoData = snapEnf.data();
          this.role = "enfermero"; // Por qué: garantizar redirección y colección correctas.
        }
      }

      if (!this.email) {
        this.email = (this.prospectoData?.email || "").trim();
      }
      if (!this.email) {
        this.errorMessage = "Correo electrónico requerido para crear la cuenta.";
      }
    } catch (error) {
      console.error("Error al cargar registro:", error);
      this.errorMessage = "Error al cargar la información del registro.";
    }
  },

  methods: {
    async crearCuenta() {
      this.errorMessage = "";

      if (!this.email) {
        this.errorMessage = "Correo electrónico no encontrado.";
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.errorMessage = "Las contraseñas no coinciden.";
        return;
      }

      this.submitting = true;

      const auth = getAuth();
      const emailNorm = this.email.trim().toLowerCase();
      const temporalPassword = (this.$route.query.pas || "").trim();

      try {
        const baseUsuario = {
          email: this.email,
          emailLower: emailNorm,
          role: this.role, // enfermero o paciente, ya fijado en mounted()
          status: "activo",
          activo: true,
          fechaRegistro: serverTimestamp(),
        };

        if (temporalPassword) {
          // === INVITACIÓN (paciente láser o enfermero) ===
          const { user } = await signInWithEmailAndPassword(
            auth,
            emailNorm,
            temporalPassword
          );

          await updatePassword(user, this.password);

          await setDoc(
            doc(db, this.role === "enfermero" ? "enfermeros" : "pacientes", user.uid),
            {
              ...(this.prospectoData || {}),
              ...baseUsuario,
              uid: user.uid,
              passwordTemporal: false,
            },
            { merge: true }
          );

          if (this.registroCol === "prospectos" && this.prospectoId) {
            await setDoc(
              doc(db, "prospectos", this.prospectoId),
              { activo: true },
              { merge: true }
            );
          }

          if (this.role === "enfermero") {
            this.$router.push(`/enfermero/calendario`);
          } else {
            this.$router.push(`/paciente/${user.uid}/informacion`);
          }
          return;
        }

        // === NO-LÁSER (paciente normal) — NO TOCAR ===
        const { user: newUser } = await createUserWithEmailAndPassword(
          auth,
          emailNorm,
          this.password
        );

        await setDoc(
          doc(db, "pacientes", newUser.uid),
          {
            ...(this.prospectoData || {}),
            ...baseUsuario,
            role: "paciente", // asegurar paciente aquí
            uid: newUser.uid,
          },
          { merge: true }
        );

        if (this.registroCol === "prePacientes" && this.prospectoId) {
          await deleteDoc(doc(db, "prePacientes", this.prospectoId));
        }

        if (this.registroCol === "prospectos" && this.prospectoId) {
          await setDoc(
            doc(db, "prospectos", this.prospectoId),
            { activo: true },
            { merge: true }
          );
        }

        this.$router.push(`/paciente/${newUser.uid}/informacion`);
        return;
      } catch (error) {
        console.error("Error al crear cuenta:", error);
        const map = {
          "auth/email-already-in-use":
            "Este correo ya está en uso. Usa el link con la contraseña temporal.",
          "auth/weak-password":
            "La contraseña es muy débil (mínimo 6 caracteres).",
          "auth/invalid-email": "Correo electrónico inválido.",
          "auth/wrong-password": "La contraseña temporal es incorrecta.",
          "auth/user-not-found": "No se encontró el usuario.",
        };

        this.errorMessage =
          map[error.code] || error.message || "Hubo un error inesperado.";
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
